import React from 'react';

function Service() {
  return (
    <div className="container p-6 px-6 mx-auto bg-white ">
      <div className="mb-16 text-center">
        <h2 className="text-base font-semibold tracking-wide text-blue-900 uppercase">
          PROCESS
        </h2>
        <p className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900  sm:text-4xl">
          Here's what we do.
        </p>
      </div>
      <div className="flex flex-wrap my-12 ">
        <div className="w-full p-8 border-b md:w-1/2 md:border-r lg:w-1/3">
          <div className="flex items-center mb-6">
            <div className="ml-4 text-xl">Temporary Staffing</div>
          </div>
          <p className="leading-loose text-gray-500 ">
            This type of staffing solution involves hiring workers on a
            temporary basis to fill short-term needs or to cover for employees
            who are on leave. The agency hires the worker and place them at the
            employer's site, and the employer pays the agency for the worker's
            time. The worker remains an employee of the agency, not of the
            employer.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 lg:w-1/3 lg:border-r">
          <div className="flex items-center mb-6">
            <div className="ml-4 text-xl">Temp to Perm Staffing</div>
          </div>
          <p className="leading-loose text-gray-500">
            This type of staffing solution is a combination of temporary and
            permanent placement. The employer hires the worker on a temporary
            basis and after a probationary period, and if the worker's
            performance is satisfactory, the employer can convert the worker to
            a permanent employee.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 md:border-r lg:w-1/3 lg:border-r-0">
          <div className="flex items-center mb-6">
            <div className="ml-4 text-xl">Permanent Staffing</div>
          </div>
          <p className="leading-loose text-gray-500 ">
            This type of staffing solution involves hiring workers on a
            permanent basis to fill long-term needs. The agency recruits and
            screens the candidates, but the employer hires the worker directly
            and the worker becomes an employee of the employer.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 lg:w-1/3 lg:border-r lg:border-b-0">
          <div className="flex items-center mb-6">
            <div className="ml-4 text-xl">Recruitment</div>
          </div>
          <p className="leading-loose text-gray-500">
            The agency helps employers find and hire qualified candidates for
            open positions. This can include posting job listings, screening
            resumes, conducting interviews, and performing background checks.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 md:border-r md:border-b-0 lg:w-1/3 lg:border-b-0">
          <div className="flex items-center mb-6">
            <div className="ml-4 text-xl">Employee Managment</div>
          </div>
          <p className="leading-loose text-gray-500 ">
            The agency can manage employee performance, attendance, and any
            other issues that may arise, and work with the employer to resolve
            them.
          </p>
        </div>
      </div>
      <div className="flex justify-center m-5">
        <button className=" bg-blue-900 text-white py-4 px-12">
          FIND OPPORTUNITIES
        </button>
      </div>
    </div>
  );
}

export default Service;
